<ng-container *ngIf="(isDeviceSet$ | async)">
    <ng-container *ngTemplateOutlet="(isMobile$ | async) === true ? mobile || null : desktop || null"></ng-container>
</ng-container>